// extracted by mini-css-extract-plugin
export default {"mainContainer":"Contact_mainContainer__-kNfr","contactLineTop":"Contact_contactLineTop__0zXrz","contactLineBottom":"Contact_contactLineBottom__89aN4"};